








import Vue, { PropType } from 'vue'

import BasePanel from 'base/components/BasePanel.vue'
import BasePanelSection from 'base/components/BasePanelSection.vue'

import { ChatLayout } from './chat-layout.interface'

export default Vue.extend({
  components: {
    BasePanel,
    BasePanelSection
  },
  props: {
    layouts: {
      type: Array as PropType<ChatLayout[]>,
      required: true
    }
  }
})
